const dashboard = '/dashboard';
const login = '/login';
const error = '/error';
const register = 'register';
const organization = 'organization';
const roles = 'roles';
const userDetails = 'user_details';
const vendorDetails = 'vendors';
const permissions = 'permissions';
const incentiveProgram = 'incentive_program';
const attribute = 'user_attr_master_mapping';
const profile = '/profile';
const bulkUser = '/bulk_User';
const bulkVendor = '/bulk_Vendor';
const certificate = 'certificate';
const orgAccessControl = '/org_access_control';

const routeName = {
  dashboard,
  login,
  error,
  register,
  userDetails,
  organization,
  roles,
  permissions,
  incentiveProgram,
  attribute,
  profile,
  bulkUser,
  vendorDetails,
  certificate,
  orgAccessControl,
  bulkVendor,
};

export default routeName;
